// extracted by mini-css-extract-plugin
var _1 = "U7UzeIOr";
export { _1 as "circle" }
